import { render, staticRenderFns } from "./QRCodes.vue?vue&type=template&id=a88eed20&scoped=true"
import script from "./QRCodes.vue?vue&type=script&lang=js"
export * from "./QRCodes.vue?vue&type=script&lang=js"
import style0 from "./QRCodes.vue?vue&type=style&index=0&id=a88eed20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88eed20",
  null
  
)

export default component.exports